<template>
    <div class="m-8 p-6 text-white bg-gray-900 bg-primary-cta bg-no-repeat items-center justify-center flex transition duration-500 ease-in-out rounded">
        <tw-card class="bg-gray-800 w-auto text-gray-900 relative text-white transition duration-500 ease-in-out mt-6">
            <racing-stars-icon class="rounded-full absolute -top-2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white p-2 bg-gray-800 text-white transition duration-500 ease-in-out" />

            <h1 class="text-3xl flex w-full justify-center mb-4 text-center text-white">Welcome to Racing Stars</h1>
            <h2 class="uppercase flex w-full justify-center mb-4 text-center text-white">To Play, Purchase Play Tokens &amp; Win Up To</h2>

            <span class="flex w-full justify-center font-bold text-center text-5xl text-racing-stars-yellow">{{ formatter.format($page.props.racingstars.dailyJackpot / 100) }}</span>

            <span class="uppercase text-1xl flex w-full justify-center text-center mb-4 text-white">Today</span>

            <span class="flex w-full justify-center font-bold text-center text-5xl text-racing-stars-yellow">{{ formatter.format($page.props.racingstars.weeklyJackpot / 100) }}</span>

            <span class="text-white uppercase text-1xl flex w-full justify-center text-center mb-4">This Week</span>
        </tw-card>
    </div>
</template>
<script>
import TwCard from '@/Global/Elements/TwCard'
import TwButton from '@/Global/Elements/TwButton'
import RacingStarsIcon from '@/Global/RacingStarsIcon'
import { getCurrentInstance } from 'vue'
import { Inertia } from '@inertiajs/inertia'

export default {
    components: {
        TwButton,
        TwCard,
        RacingStarsIcon,
    },
    setup(props) {

        /**
         * Formatter function required to format currencies/prices correctly.
         * 
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const play = () => {
            Inertia.get(route('play'))
        }

        return {
            formatter,
            play,
        }
    }
}

</script>
